import {defaultKeywords} from "../keywords";

export const seoContentMapRu = {
    '/': {
        title: "Rodin — Бесплатный AI-генератор 3D-моделей из изображений | Hyper3D",
        description: "Создавайте впечатляющие 3D-модели с помощью ИИ за считанные секунды. Генерируйте 3D-модели из текста или изображений с лёгкостью и совершайте революцию в вашем творческом процессе уже сегодня.",
        keywords: defaultKeywords,
        h1Text: "Rodin — Бесплатный AI-генератор 3D-моделей на основе текста и изображений",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin — AI-генератор 3D-моделей бесплатно | Hyper3D",
        description: "Создавайте впечатляющие 3D-модели с помощью ИИ за считанные секунды. Генерируйте 3D-модели из текста или изображений с лёгкостью и уже сегодня сделайте шаг в будущее творчества!",
        keywords: defaultKeywords,
        h1Text: "Rodin — Бесплатный AI-генератор 3D-моделей на основе текста и изображений",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin — AI-генератор 3D-моделей",
        description: "Создавайте впечатляющие 3D-модели с помощью ИИ за считанные секунды. Генерируйте 3D-модели из текста или изображений с лёгкостью и уже сегодня сделайте шаг в будущее творчества!",
        keywords: defaultKeywords,
        h1Text: "Rodin — Бесплатный AI-генератор 3D-моделей на основе текста и изображений",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar"
    },
    '/rodin/search': {
        title: "3D-модели | Hyper3D",
        description: "Готовы к просмотру и бесплатному скачиванию в форматах fbx, obj, glb и usd. Для игр, VR/AR, видеопроизводства и 3D-печати.",
        keywords: defaultKeywords,
        h1Text: "Rodin — Бесплатный AI-генератор 3D-моделей на основе текста и изображений",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar"
    },
    '/rodin/tab/story': {
        title: "Rodin — Подборка пользовательских историй | Hyper3D",
        description: "Исследуйте разнообразные истории пользователей и узнайте, как Rodin меняет творческий процесс для художников и дизайнеров.",
        keywords: defaultKeywords,
        h1Text: "Rodin — Бесплатный AI-генератор 3D-моделей на основе текста и изображений",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar — AI-генератор 3D-лиц | Hyper3D",
        description: "ChatAvatar от Hyper3D создает готовые к производству, ультрареалистичные 3D-лица с PBR-текстурами из текста или изображений за считанные минуты.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar — Генератор 3D-лиц",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar — AI-генератор 3D-лиц | Hyper3D",
        description: "ChatAvatar от Deemos Hyper3D создает готовые к производству, ультрареалистичные 3D-лица с PBR-текстурами из текста или изображений за считанные минуты.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar — Генератор 3D-лиц",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "Цены | Hyper3D",
        description: "Подпишитесь на Hyper3D и получите доступ к эксклюзивным функциям и контенту.",
        keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
        h1Text: "Подписка — Hyper3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "API Dashboard | Hyper3D",
        description: "Управляйте своими ключами API Hyper3D и отслеживайте статистику использования.",
        keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
        h1Text: "API Dashboard",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "Войти | Hyper3D",
        description: "Получите доступ к своей учетной записи Hyper3D. Бесплатно в использовании. Попробуйте легко. Просто напишите, и Hyper3D поможет в моделировании, текстурировании и многом другом.",
        keywords: defaultKeywords + "Login, Hyper3D, User, Account",
        h1Text: "Вход",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "Регистрация | Hyper3D",
        description: "Создайте новую учетную запись Hyper3D. Бесплатно в использовании. Легко попробовать. Просто напишите, и Hyper3D поможет в моделировании, текстурировании и многом другом.",
        keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
        h1Text: "Регистрация",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "Политика конфиденциальности | Hyper3D",
        description: "Ознакомьтесь с политикой конфиденциальности Hyper3D, чтобы узнать, как мы обрабатываем ваши данные.",
        keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
        h1Text: "Политика конфиденциальности",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "Условия использования | Hyper3D",
        description: "Ознакомьтесь с условиями и положениями Hyper3D. Эти условия регулируют процесс создания с помощью сервисов Hyper3D.",
        keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
        h1Text: "Условия использования",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "Часто задаваемые вопросы | Hyper3D",
        description: "Найдите ответы на распространенные вопросы о продуктах и услугах Hyper3D.",
        keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
        h1Text: "Часто задаваемые вопросы",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft — 3D-инструментарий | Hyper3D",
        description: "OmniCraft — это бесплатный онлайн-инструментарий для 3D-моделирования, разработанный для 3D-художников, геймдизайнеров, дизайнеров и многих других.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
        h1Text: "Создайте свой собственный виртуальный мир из изображений, текста и воображения",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "Генератор HDRI-панорам — Создайте свой виртуальный мир | Hyper3D",
        description: "Создавайте свой виртуальный мир с помощью генератора HDRI-панорам за считанные секунды. Из изображений, текста и воображения.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
        h1Text: "Создайте свой собственный виртуальный мир из изображений, текста и воображения",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "Конвертер 3D-форматов — Бесплатно и полностью офлайн | Hyper3D",
        description: "Просто перетащите свой 3D-файл, чтобы конвертировать его в любой популярный формат, такой как obj, fbx, gltf, glb и usd. Бесплатно и работает полностью офлайн.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Бесплатный, безопасный и полностью офлайн-конвертер 3D-моделей",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "3D-моделирование (скульптинг) — Бесплатно и полностью офлайн | Hyper3D",
        description: "Инструмент 3D-скульптинга, поддерживающий все популярные форматы, включая obj, fbx, 3ds, dxf, glb и usd. Бесплатно и полностью офлайн.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Бесплатный, безопасный и полностью офлайн-конвертер 3D-моделей",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin Search — Поисковая система 3D-моделей | Hyper3D",
        description: "3D-поисковая система, которая быстро находит 3D-модели на Sketchfab, Daz3D и Rodin с помощью изображений, текста или самой 3D-модели.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Rodin Search — Поисковая система 3D-моделей",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "3D-просмотрщик — Бесплатно и полностью офлайн | Hyper3D",
        description: "3D-просмотрщик, поддерживающий все популярные форматы: obj, fbx, stl, gltf, 3ds, dxf, ply, glb и usd.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Бесплатный, безопасный и полностью офлайн-просмотрщик 3D-моделей",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "Генератор 3D-текстур — 3D-текстуры из изображений | Hyper3D",
        description: "ИИ-генератор текстур, который позволяет каждому воплощать в жизнь модели, игры, AR/VR и искусство, используя реалистичные текстуры из изображений.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Бесплатный, безопасный и полностью офлайн-генератор 3D-текстур",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D — Революционное 3D-моделирование с помощью Rodin и ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    }
}